import {AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import {loadParameterFromJson, saveParameterToJson} from 'parameters/parameterJsonFunctions.js';
import ParameterContext from 'effects/ParameterContext.js';
        
class InstrumentRackInstrument {
    constructor(track, instrumentRack) {
        this.track = track;
        this.instrumentRack = instrumentRack;
        this.track.instrumentRack = this.instrumentRack;
        this.sequencerEngine = track.sequencerEngine;
        this.store = this.sequencerEngine.store;

        this.parameters = [];

        this.volumeParameter = new AudioParamValueParameter(
            'volume', this.track.volumeNode.volume , {
                min: 0,
                max: 1,
                unit: 'db',
                defaultValue: 0
            });
        this.registerParameter(this.volumeParameter);

        this.track.effectsChains[0].parameterContext = new ParameterContext().forTrack(instrumentRack);
        if (this.track.instrument) { 
            let parameters = this.track.instrument.parameters;
            for (let i in parameters) {
                parameters[i].setContext(
                    parameters[i].context
                        .forSubDevice(parameters[i].track)
                        .forTrack(instrumentRack));
            }
        }

        this.track.instrumentRack = instrumentRack;
    }

    dispose() {
        this.track.dispose(undefined, this.instrumentRack.isFrozen);
    }

    get effectsChains() {
        return this.track.effectsChains;
    }

    get presetName() {
        return this.track.presetName;
    }

    getName() {
        return this.track.getName();
    }

    get trackNumber() {
        return this.track.trackNumber;
    }

    registerParameter(parameter) {
        parameter.setStore(this.store);
        parameter.setContext(new ParameterContext().forTrack(this.instrumentRack));
        this.parameters.push(parameter);
    }

    getJson(skipFreeze) {
        let json = {
            track: this.track.getJson(skipFreeze),
            effectsChains: this.track.effectsChains.map(
                chain => chain.getJson()),
            midiEffects: this.track.midiEffects.getJson(),
            volume: this.volumeParameter.get(),
            sendVolumes: this.track
                .getSendNodes()
                .map(send => send.volume.value)
        };

        json = saveParameterToJson(json, 'volumeParameter', this.volumeParameter);
        return json;
    }

    async fromJson(json, trackNumber) {
        await this.track.fromJson(json.track, false);
        this.track.effectsChains[0].clear();
        this.track.effectsChains[0].fromJson(
            json.effectsChains[0], this.sequencerEngine.tracks, trackNumber);
        this.track.midiEffects.fromJson(
            json.midiEffects);
        this.volumeParameter.set(json.volume);

        if (json.sendVolumes) {
            let sendNodes = this.track.getSendNodes();
            for (
                let sendNumber=0;
                sendNumber < Math.min(json.sendVolumes.length, sendNodes.length);
                sendNumber++)
            {
                sendNodes[sendNumber].volume.value = json.sendVolumes[sendNumber];
            }
        }
        loadParameterFromJson(json, 'volumeParameter', this.volumeParameter, this.sequencerEngine);
    }

    async getCopy() {
        let track = await this.track.getCopy();
        let instrumentRackInstrument = new InstrumentRackInstrument(
            track, 
            this.instrumentRack
        );
        let json = this.getJson();
        await instrumentRackInstrument.fromJson(json);
        return instrumentRackInstrument;
    }

    getAllParameters() {
        return [
            ... this.parameters,
            ... this.track.getAllParameters(),
        ];
    }
}

export default InstrumentRackInstrument;
